import { render, staticRenderFns } from "./payment-status.vue?vue&type=template&id=4f8b9a60&scoped=true"
import script from "./payment-status.vue?vue&type=script&lang=js"
export * from "./payment-status.vue?vue&type=script&lang=js"
import style0 from "./payment-status.vue?vue&type=style&index=0&id=4f8b9a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b9a60",
  null
  
)

export default component.exports